import { Component, OnInit, Input } from '@angular/core';
import { PictographConfiguration, PictographYearConfiguration } from "./pictograph.configuration";
import { TitleLineConfigurations, TitleConfigurations } from "../title/title.configurations";
import { KlaHttpService } from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { RoundButtonComponent } from '../round-button/round-button.component';
import { TitleComponent } from '../title/title.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-pictograph',
  templateUrl: './pictograph.component.html',
  styleUrls: ['./pictograph.component.scss'],
  standalone: true,
  imports: [ CommonModule, RoundButtonComponent, TitleComponent, DynamicContentComponent ]
})
export class PictographComponent implements OnInit {

  @Input()
  public pictographConfig: PictographConfiguration

  @Input()
  public config: {
    chartId: string,
    image: string,
    title: TitleConfigurations
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  public maxNumber = [];

  public activePictograph: PictographYearConfiguration;

  public showSecondPictograph: boolean = false;

  public selectedButton: number = 0;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    this.httpService.getChartData("kla-pictograph", this.config.chartId).subscribe(
      (data) => {
        this.pictographConfig = {
          data: data ? data.items : undefined
        }

        if (!this.pictographConfig.data) {
          console.error("Please provide pictograph chart configurations");
        } else {
          this.initPictograph();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }
  initPictograph() {

    this.maxNumber = Array.from(Array(100).keys())
    this.activePictograph = this.pictographConfig.data[0];
    this.activePictograph.firstGraph.percentage = Math.round(this.activePictograph.firstGraph.percentage);

    this.checkSecondGraph();
  }

  changeActivePictograph(index: number) {
    this.selectedButton = index;
    this.showSecondPictograph = false;
    this.activePictograph = this.pictographConfig.data[index];
    this.checkSecondGraph();
  }
  checkSecondGraph() {
    if (this.activePictograph.secondGraph) {
      this.showSecondPictograph = true;
      this.activePictograph.secondGraph.percentage = Math.round(this.activePictograph.secondGraph.percentage);
    }
  }

}
